module.exports = __webpack_public_path__ + "static/img/img11-1-1-1.a506b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img11-1-1-1.png
// module id = cvC8
// module chunks = 0